import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DateFormatter from 'Common/Components/DateFormatter';
import { FiTrash2 as Remove, FiEdit3 as Edit /* , FiMessageSquare as MessageIcon */ } from 'react-icons/fi';
import { FEATURE_COMMENTS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';
import { useDispatch, useSelector } from 'react-redux';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import {
  CommentsItem,
  CommentsAuthor,
  CommentsDate,
  CommentRemove,
  CommentEdit,
  CommentContainer,
  ButtonsContainer
} from './styled';
import EditableMarkdown from '../EditableMarkdown';
import { updateComment } from 'store/ManageGeneral/actions';
import { selectVulnDetail } from 'store/ManageGeneral/selectors';
import { selectDetail as selectVulnDetailAsset } from 'store/Contextualization/AssetDetail/selectors';
import { selectVulnDetail as selectVulnDetailManage } from 'store/Manage/selectors';
import { get } from 'lodash';
import { useLocation } from 'react-router-dom';

const UserComment = ({
  comment, isCreator, onRemove
}) => {
  const props = useSelector((state) => ({
    canEdit: selectAllowedByRole(state, FEATURE_COMMENTS, PERMISSION_TYPES.UPDATE),
    canDelete: selectAllowedByRole(state, FEATURE_COMMENTS, PERMISSION_TYPES.DELETE)
  }));

  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const onClickEdit = () => setIsEditing(true);

  const vulnDetailHost = useSelector(state => selectVulnDetailAsset('vulns', state));
  const vulnDetailManage = useSelector(selectVulnDetailManage);
  const vulnDetailGeneralManage = useSelector(selectVulnDetail);

  let seletedVuln;

  if (pathname.startsWith('/host/')) {
    seletedVuln = vulnDetailHost;
  } else if (pathname.startsWith('/vulnerabilities')) {
    seletedVuln = vulnDetailGeneralManage;
  } else if (pathname.startsWith('/manage/')) {
    seletedVuln = vulnDetailManage;
  }

  const vulnWs = get(seletedVuln, 'workspace_name', 0);

  return (
    <CommentsItem>
      <CommentContainer>
        <CommentsDate><DateFormatter date={ comment.create_date } /></CommentsDate>
        <CommentsAuthor>{`${comment.creator}: `}</CommentsAuthor>
        <EditableMarkdown
          onSave={ (value) => dispatch(updateComment(vulnWs, value)) }
          comment={ comment }
          isEditing={ isEditing }
          setIsEditing={ setIsEditing }
          isCreator={ isCreator }
          allowedToEdit={ props.canEdit }
        />
      </CommentContainer>
      {isCreator &&
    (
    <ButtonsContainer>
      {props.canDelete && (
      <CommentRemove onClick={ () => onRemove(comment) }>
        <Remove color="#bec8d2" size="1.2em" />
      </CommentRemove>
      )}
      {props.canEdit && (
      <CommentEdit onClick={ () => onClickEdit() }>
        <Edit color="#bec8d2" size="1.2em" />
      </CommentEdit>
      )}
    </ButtonsContainer>
    )}
    </CommentsItem>
  );
};

UserComment.propTypes = {
  comment: PropTypes.shape({
    create_date: PropTypes.string.isRequired,
    creator: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  isCreator: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired
};

export default UserComment;
